<template>
    <div id="new-openai-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-form-item
                        :validate-status="getErrorStatus('channelName')"
                        :help="getErrorMessage('channelName')"
                    >
                        <a-input
                            v-model="form.channelName"
                            :placeholder="$t('whatsappChannel.channelName')"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>
                <div class="input-wrapper">
                    <label>OpenAI API KEY</label>
                    <a-input placeholder="OpenAI API KEY" v-model="form.apiKey" v-validate="'required'" name="apiKey" />
                </div>

               <!-- <div class="input-wrapper ai-assistant">
                    <div
                        class="ai-assistant"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="'Eğer aktif etmez iseniz, yapay asistan kullanımları Supsis tarafından sağlanır ay sonunda faturalandırılır.'"
                    >
                        Yapay Zeka Asistan Kullanımını Dahil Et
                        <span class="material-icons"> help </span>
                    </div>
                    <div>
                        <a-switch v-model="form.settings.useAIAssistant" />
                    </div>
                </div>-->
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">{{ $t("message.cancel") }}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("message.save") }}</a-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "NewOpenAIChannel",
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
        update: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    data() {
        return {
            form: {
                channelName: this.$_.get(this.channel, "name", ""),
                apiKey: this.$_.get(this.channel, "payload.apiKey", ""),
                settings: {
                    useAIAssistant: this.$_.get(this.channel, "payload.settings.useAIAssistant", false),
                },
            },
            loading: false,
            clone: _.cloneDeep(this.channel),
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({}),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            updateChannel: "channel/updateChannel",
        }),
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        handleCancel() {
            this.$emit("cancel");
        },
        handleSave() {
            if (this.update) {
                this.loading = true;
                this.updateChannel({
                    ...this.channel,
                    type: "openai",
                    name: this.form.channelName,
                    payload: {
                        apiKey: this.form.apiKey,
                        settings: {
                            useAIAssistant: this.form.settings.useAIAssistant,
                        },
                    },
                })
                    .then(() => {
                        this.$message.success("Channel updated successfully");
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                return;
            }
            this.submitClicked = true;
            if (this.form.channelName.length < 1) {
                this.$refs.channelName.focus();
                return;
            } else {
                const isValid = true;
                if (isValid) {
                    const payload = {
                        type: "openai",
                        name: this.form.channelName,
                        payload: {
                            apiKey: this.form.apiKey,
                            settings: {
                                useAIAssistant: this.form.settings.useAIAssistant,
                            },
                        },
                    };
                    this.loading = true;
                    this.createChannel(payload)
                        .then(() => {
                            this.$message.success(this.$t("message.channelCreatedSuccessfully"));
                            this.$emit("ok");
                        })
                        .catch((err) => {
                            this.$message.error(this.$t("message.failedToCreateChannel"));
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
        },
    },
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#new-openai-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;

            &.ai-assistant {
                width: fit-content;

                .ai-assistant {
                    font-size: 14px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                }
            }
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>

<style lang="scss">
.new-sms-postacell {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
